import React from "react";
import { Link } from "gatsby";
import { Case_Arrow, Case_ArrowFlutterusa } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Caseusa = () => {
  return (
    <section className="case_flex">
      <div className="flex_item" style={{ backgroundColor: "#4145A9" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/flutter/case-logo-1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={85}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Reck’N mobile app to life</h3>
            <Link
              to="/case-studies/reck-n-case"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/flutter/case-study-1.webp"
            alt="Reck’N mobile app"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={675}
            height={460}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#f3f3f3" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/flutter/case-logo-2.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={198}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3 style={{ color: "#000" }}>
              An Interactive Social Platform to Connect Friends and Family
            </h3>
            <Link
              to="/case-studies/saleh"
              className="case-usabtn"
              aria-label="TekRevol Contact"
              style={{ color: "#000" }}
            >
              View Case Study {Case_ArrowFlutterusa}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/flutter/case-study-2.webp"
            alt="Selah"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#6fbcdf" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/flutter/case-logo-3.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={194}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>OnSite Social is a revolutionary mobile application</h3>
            <Link
              to="/case-studies/onsite"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/flutter/case-study-3.webp"
            alt="Onsite Social "
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
    </section>
  );
};

export default Caseusa;
